/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetToJSON,
} from './Asset';

/**
 * A link box/card on the home page
 * @export
 * @interface LinkBox
 */
export interface LinkBox {
    /**
     *
     * @type {string}
     * @memberof LinkBox
     */
    id?: string | null;
    /**
     *
     * @type {string}
     * @memberof LinkBox
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof LinkBox
     */
    displayName: string;
    /**
     *
     * @type {Asset}
     * @memberof LinkBox
     */
    icon?: Asset | null;
    /**
     *
     * @type {string}
     * @memberof LinkBox
     */
    href: string;
    /**
     *
     * @type {Array<string>}
     * @memberof LinkBox
     */
    targetAudience: string[];
    /**
     *
     * @type {Array<string>}
     * @memberof LinkBox
     */
    targetCountries: string[];
    /**
     *
     * @type {Array<string>}
     * @memberof LinkBox
     */
    targetPositions: string[];
}

/**
 * Check if a given object implements the LinkBox interface.
 */
export function instanceOfLinkBox(value: object): value is LinkBox {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('href' in value) || value['href'] === undefined) return false;
    if (!('targetAudience' in value) || value['targetAudience'] === undefined) return false;
    if (!('targetCountries' in value) || value['targetCountries'] === undefined) return false;
    if (!('targetPositions' in value) || value['targetPositions'] === undefined) return false;
    return true;
}

export function LinkBoxFromJSON(json: any): LinkBox {
    return LinkBoxFromJSONTyped(json, false);
}

export function LinkBoxFromJSONTyped(json: any, _: boolean): LinkBox {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'] ?? undefined,
        'title': json['title'],
        'displayName': json['display_name'],
        'icon': json['icon'] == null ? undefined : AssetFromJSON(json['icon']),
        'href': json['href'],
        'targetAudience': json['target_audience'],
        'targetCountries': json['target_countries'],
        'targetPositions': json['target_positions'],
    };
}

export function LinkBoxToJSON(json: any): LinkBox {
    return LinkBoxToJSONTyped(json, false);
}

export function LinkBoxToJSONTyped(value?: LinkBox | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'title': value['title'],
        'display_name': value['displayName'],
        'icon': AssetToJSON(value['icon']),
        'href': value['href'],
        'target_audience': value['targetAudience'],
        'target_countries': value['targetCountries'],
        'target_positions': value['targetPositions'],
    };
}
